exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.container[data-v-488666c4] {\n  padding: 16px;\n}\np[data-v-488666c4] {\n  margin: 0;\n}\n", "", {"version":3,"sources":["/opt/build/repo/src/components/Professionals/Edit/Tabs/Register/Steps/src/components/Professionals/Edit/Tabs/Register/Steps/AccessDenied.vue"],"names":[],"mappings":";AAUA;EACA,cAAA;CACA;AAEA;EACA,UAAA;CACA","file":"AccessDenied.vue","sourcesContent":["<template>\n  <div class=\"container\">\n    <p>\n      O acesso do profissional foi negado por não cumprir com alguns dos\n      requisitos necessários para a utilização do app.\n    </p>\n  </div>\n</template>\n\n<style scoped>\n.container {\n  padding: 16px;\n}\n\np {\n  margin: 0;\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-488666c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Professionals/Edit/Tabs/Register/Steps/AccessDenied.vue
// module id = MYv4
// module chunks = 1